module.exports = __webpack_public_path__ + "img/xiaomi-8.2f95a78f.png";